import {
  fetchLists,
  removeItemFromList,
  createGuestList,
  addItemToList,
} from './bao-swym.js'

class WishlistButton extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isLoggedIn = !!window.ShopifyAnalytics.meta.page.customerId
    this.lists = []
  }

  initWishlistButton () {
    if (!this.isLoggedIn) {
      if (!window.SwymCallbacks) {
        window.SwymCallbacks = []
      }

      const initGuest = () => {
        fetchLists(false)
          .then(lists => {
            if (lists.length === 0) {
              createGuestList()
                .then(list => {
                  this.lists = [list]
                  this.updateWishlistButton([list])
                  this.removeAttribute('disabled')
                })
                .catch(err => console.error(err))
            } else {
              this.lists = lists
              this.updateWishlistButton(lists)
              this.removeAttribute('disabled')
            }
          })
          .catch(err => console.error(err))
      }

      if (window._swat) {
        initGuest()
      } else {
        window.SwymCallbacks.push(initGuest)
      }

      return
    }

    const initLoggedIn = () => {
      fetchLists().then(lists => {
        this.lists = lists
        this.updateWishlistButton(lists)
        this.removeAttribute('disabled')
      })
    }

    if (window._swat) {
      initLoggedIn()
    } else {
      if (!window.SwymCallbacks) {
        window.SwymCallbacks = []
      }
      window.SwymCallbacks.push(initLoggedIn)
    }
  }

  setupListeners () {
    super.setupListeners()

    this.addEventListener('click', this.wishlistToggle)

    document.addEventListener('swym-item-added', data => {
      const { product } = data.detail

      if (product.empi === this.dataset.product) {
        this.classList.add(this.addedToWishlistClass)
      }
    })

    if (window.SwymCallbacks) {
      this.initWishlistButton()
    }

    window.addEventListener('PandectesEvent_OnConsent', e => {
      if (e.detail.consentType === 'new' || e.detail.consentType === 'stored') {
        this.initWishlistButton()
      }
    })
  }

  updateWishlistButton (lists) {
    const productId = this?.dataset?.product

    lists.forEach(list => {
      const { listcontents } = list

      if (!listcontents) return

      const item = listcontents.find(
        item => parseInt(item.empi) === parseInt(productId),
      )

      if (item) {
        this.classList.add(this.addedToWishlistClass)

        this.dataset.listId = list.lid
      }
    })
  }

  async wishlistToggle () {
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = []
    }

    const productId = this.dataset.product

    const { variant, productImage, productTitle, handle } = this.dataset

    if (this.classList.contains(this.addedToWishlistClass)) {
      fetchLists(false).then(lists => {
        lists.forEach(list => {
          const { listcontents } = list

          const item = listcontents.find(
            item => parseInt(item.empi) === parseInt(productId),
          )

          if (item) {
            const productData = {
              epi: item.epi,
              empi: item.empi,
              du: item.du,
            }

            if (!window.SwymCallbacks) {
              window.SwymCallbacks = []
            }

            window.SwymCallbacks.push(() =>
              removeItemFromList(list.lid, productData)
                .then(() => {
                  this.classList.remove(this.addedToWishlistClass)
                })
                .catch(err => console.error(err)),
            )
          }
        })
      })
    } else {
      if (!this.isLoggedIn) {
        const product = {
          epi: variant,
          empi: productId,
          du: `${window.location.origin}/products/${handle}?variant=${variant}`,
        }

        const details = {
          wishlistName: this.lists[0].lname,
          productImage,
          productTitle,
        }

        if (!window.SwymCallbacks) {
          window.SwymCallbacks = []
        }

        window.SwymCallbacks.push(() =>
          addItemToList(this.lists[0].lid, product, details),
        )

        return
      }

      const modalContent = await fetch(
        `/products/${handle}?section_id=wishlist-modal`,
      )
      const modalContentText = await modalContent.text()

      const container = document.querySelector('.wishlist-modal-container')
      container.innerHTML = modalContentText

      const modal = container.querySelector('wishlist-modal')
      modal.show()
    }
  }

  get wishlistLocalStorage () {
    if (typeof Storage !== 'undefined' && localStorage.getItem('swym-lists')) {
      return JSON.parse(localStorage.getItem('swym-lists'))
    }

    return null
  }

  get variantId () {
    return this?.dataset?.variant
  }

  get addedToWishlistClass () {
    return 'wsh-WishlistButton-added'
  }
}

if (!customElements.get('wishlist-button')) {
  customElements.define('wishlist-button', WishlistButton)
}
